import React from 'react';
import { Button, Dropdown, Menu, Space } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
// Helpers
import getEnvVariables from 'api/env';
import { getProperErrorMessage } from 'helpers/errors';
// Api
import {
  CREATE_CAMPAIGN_COLLAB_INVITE,
  REMOVE_CAMPAIGN_COLLAB,
} from 'api/campaignV2/mutations';
// Types
import { GetCampaignsV2_getCampaigns_entities_collaborators } from 'api/campaignV2/types/GetCampaignsV2';
import {
  RemoveCampaignCollab,
  RemoveCampaignCollabVariables,
} from 'api/campaignV2/types/RemoveCampaignCollab';

import {
  CreateCampaignCollabInvite,
  CreateCampaignCollabInviteVariables,
} from 'api/campaignV2/types/CreateCampaignCollabInvite';
// UI
import { successNotification, errorNotification } from 'ui/Notification';

type CollaborationActionsProps = {
  record: GetCampaignsV2_getCampaigns_entities_collaborators;
  campaignId: string;
  onClose: () => void;
  refetch: () => void;
};

const CollaborationActions = ({
  record,
  campaignId,
  onClose,
  refetch,
}: CollaborationActionsProps): JSX.Element => {
  const [createCampaignCollabInvite] = useMutation<
    CreateCampaignCollabInvite,
    CreateCampaignCollabInviteVariables
  >(CREATE_CAMPAIGN_COLLAB_INVITE);

  const [removeCampaignCollab] = useMutation<
    RemoveCampaignCollab,
    RemoveCampaignCollabVariables
  >(REMOVE_CAMPAIGN_COLLAB);

  const handleCopyInviteLink = async () => {
    const roleId = record.role?.roleId;
    if (!campaignId || !roleId) {
      return;
    }
    try {
      const { data } = await createCampaignCollabInvite({
        variables: {
          input: {
            campaignId,
            roleId: record.role?.roleId || '',
          },
        },
      });

      successNotification('Invite created!');

      if (data) {
        const inviteLink = `${getEnvVariables.CAMPAIGN_APP_URL}/collaboration-invite/${campaignId}/${data?.createCampaignCollabInvite?.invite}`;
        navigator.clipboard.writeText(inviteLink);
        successNotification('Link copied to clipboard');
      }
    } catch (error) {
      errorNotification(getProperErrorMessage(error, 'Something went wrong!'));
    }
  };
  const handleRemoveCollaborator = async (userId: string | undefined) => {
    if (!userId) {
      return;
    }
    try {
      await removeCampaignCollab({
        variables: {
          input: {
            userId,
            campaignId,
          },
        },
      });

      successNotification('Collaborator removed!');

      refetch();
      onClose();
    } catch (error) {
      errorNotification(getProperErrorMessage(error, 'Something went wrong!'));
    }
  };
  const getMenu = () => {
    return (
      <Menu>
        <Space direction="vertical" size="middle" align="center">
          <Menu.Item key="remove">
            <Button onClick={handleCopyInviteLink}>Copy Invite Link</Button>
          </Menu.Item>
          <Menu.Item key="edit">
            <Button onClick={() => handleRemoveCollaborator(record.user?.id)}>
              Remove
            </Button>
          </Menu.Item>
        </Space>
      </Menu>
    );
  };
  return (
    <>
      <Dropdown
        trigger={['click']}
        placement="bottomCenter"
        overlay={getMenu()}
      >
        <Button
          aria-label="show the available actions"
          icon={<EllipsisOutlined />}
        />
      </Dropdown>
    </>
  );
};

export default CollaborationActions;
